import React from 'react';
import { css, cx } from 'linaria';
const modalBodyStyles = "mweydr9";
export const ModalBody = ({
  children,
  className
}) => <div className={cx(modalBodyStyles, className)}>{children}</div>;
export default ModalBody;

require("./modal-body.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./modal-body.js");